<template>
    <div>


        <!--        <h1 class="mb-8 font-bold text-3xl">-->
        <!--            <Link class="text-indigo-400 hover:text-indigo-600" :href="this.route('tickets')">{{ __('Tickets') }}</Link>-->
        <!--            <span class="text-indigo-400 font-medium">/</span> {{ __('Create') }}-->
        <!--        </h1>-->
        <div class="bg-white rounded-md shadow overflow-hidden max-w-full">
            <form @submit.prevent="store">
                <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

                    <text-input v-model="form.order_code" :error="form.errors.order_code"
                                class="pr-6 pb-4 w-full lg:w-full" :label="__('Order Code')"
                                @blur="validateOrderCode"/>

                    <div class="-mr-6 flex w-full justify-between  pb-4 lg:w-full">
                        <div>
                            <button :disabled="loading "
                                    @click="fetchOrderData"
                                    class="rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">
                                <span v-if="loading">Loading...</span>
                                <span v-else>Find</span>
                            </button>
                        </div>
                        <div v-if="orderDetails">
                            {{ orderDetails.billing_address.first_name }} {{ orderDetails.billing_address.last_name }} |
                            {{ orderDetails.customer.email }} |
                            {{ orderDetails.billing_address.phone }} |
                            PKR {{ orderDetails.current_subtotal_price }} |
                            {{ orderDetails.payment_gateway_names }}
                        </div>


                        <div class="flex justify-between gap-3 px-6">
                                                        <button v-if="orderDetails && orderDetails.order_status_url"
                                                                @click="openShopifyLink"
                                                                class="rounded-md bg-green-600/90 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-600/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600/90">
                                                            Shopify
                                                        </button>
                            <button
                                v-if="orderDetails && orderDetails.name"
                                type="button"
                                @click="openGingkoLink"
                                class="rounded-md bg-indigo-500/90 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500/80">
                                Gingko
                            </button>
                            <button
                                v-if="orderDetails && orderDetails.fulfillments[0]?.tracking_url !== null"
                                type="button"
                                @click="openCourierLink"
                                class="rounded-md bg-red-600/85 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-600/85 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600/85">
                                Courier
                            </button>

                        </div>
                    </div>

                    <select-input v-if="user_access.ticket.update" v-model="form.priority_id"
                                  :error="form.errors.priority_id" class="pr-6 pb-8 w-full lg:w-1/3"
                                  :label="__('Priority')">
                        <option :value="null"/>
                        <option v-for="s in priorities" :key="s.id" :value="s.id">{{ s.name }}</option>
                    </select-input>

                    <select-input v-if="!(hidden_fields && hidden_fields.includes('department'))"
                                  v-model="form.department_id" :error="form.errors.department_id"
                                  class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Department')" :required="true">
                        <option :value="null"/>
                        <option v-for="s in departments" :key="s.id" :value="s.id">{{ s.name }}</option>
                    </select-input>


                    <select-input v-if="!(hidden_fields && hidden_fields.includes('ticket_type'))"
                                  v-model="form.type_id" :error="form.errors.type_id" class="pr-6 pb-8 w-full lg:w-1/3"
                                  :label="__('Ticket Type')" :required="true">
                        <option :value="null"/>
                        <option :value="null"/>
                        <option v-for="s in types" :key="s.id" :value="s.id">{{ s.name }}</option>
                    </select-input>

                    <select-input-filter placeholder="Start typing" :onInput="handleSearchInput"
                                         :items="userFetchAllDepartment"
                                         v-if="user_access.ticket.update && !(hidden_fields && hidden_fields.includes('assigned_to'))"
                                         v-model="form.assigned_to" :error="form.errors.assigned_to"

                                         class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Assigned to')">
                    </select-input-filter>

                    <!--                    <select-input v-if="!(hidden_fields && hidden_fields.includes('category'))"-->
                    <!--                                  v-model="form.category_id" :error="form.errors.category_id"-->
                    <!--                                  class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Category')" :required="true">-->
                    <!--                        <option :value="null"/>-->
                    <!--                        <option v-for="s in categories" :key="s.id" :value="s.id">{{ s.name }}</option>-->
                    <!--                    </select-input>-->


                    <text-input v-model="form.subject" :error="form.errors.subject" class="pr-6 pb-8 w-full lg:w-full"
                                :label="__('Subject')"/>
                    <div class="pr-6 pb-8 w-full">
                        <label class="form-label">Request Details:</label>
                        <ckeditor id="ticketDetails" :editor="editor" v-model="form.details"
                                  :config="editorConfig"></ckeditor>
                    </div>
                    <input ref="file" type="file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf, .zip"
                           class="hidden" multiple="multiple" @change="fileInputChange"/>
                    <div class="pr-6 pb-8 w-full lg:w-full flex-col">
                        <button type="button" class="btn flex justify-center items-center" @click="fileBrowse">
                            <icon name="file" class="flex-shrink-0 h-8 fill-gray-400 pr-1"/>
                            <h4>{{ __('Attach files') }}</h4>
                        </button>
                        <div v-if="form.files.length"
                             class="flex items-center justify-between pr-6 pt-8 w-full lg:w-1/2"
                             v-for="(file, fi) in form.files" :key="fi">
                            <div class="flex-1 pr-1">
                                {{ file.name }} <span class="text-gray-500 text-xs">({{
                                    getFileSize(file.size)
                                }})</span>
                            </div>
                            <button type="button" class="btn flex justify-center items-center"
                                    @click="fileRemove(file, fi)">
                                {{ __('Remove') }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Create') }}
                        {{ __('Ticket') }}
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Link} from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import SelectInputFilter from '@/Shared/SelectInputFilter'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import UploadAdapter from '@/Shared/UploadAdapter';
import CKEditor from '@ckeditor/ckeditor5-vue';
import axios from 'axios'


export default {
    metaInfo: {title: 'Create Ticket'},
    components: {
        LoadingButton,
        SelectInput,
        SelectInputFilter,
        TextInput,
        TextareaInput,
        Link,
        Icon,
        ckeditor: CKEditor.component,
    },
    layout: Layout,
    props: {
        customers: Array,
        userFetchAllDepartment: Array,
        priorities: Array,
        statuses: Array,
        types: Array,
        departments: Array,
        categories: Array,
        auth: Object,
        hidden_fields: Object,
        departmentId: Number,
        shopifySetting: Object,


    },
    remember: false,
    data() {
        return {
            user_access: this.$page.props.auth.user.access,

            editor: ClassicEditor,
            editorConfig: {
                toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'outdent', 'indent', '|', 'insertTable', 'blockQuote', '|', 'imageUpload', 'mediaEmbed', '|', 'undo', 'redo'],
                table: {
                    toolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
                },
                extraPlugins: [this.uploader],
            },
            form: this.$inertia.form({
                user_id: null,
                priority_id: null,
                status_id: null,
                department_id: this.auth.user.department_id,
                category_id: null,
                assigned_to: null,
                order_code: null,
                type_id: null,
                subject: null,
                details: '',
                files: [],
            }),
            orderDetails: null,
            loading: false,
            departId: this.auth.user.department_id ?? null,
        }
    },
    created() {
        // Ensure auth data is available

        const department = this.departments.find(dep => dep.id === this.form.department_id);

        this.setDefaultValue(this.departments, 'department_id', department.name);

        // Set other default values as needed
        this.setDefaultValue(this.statuses, 'status_id', 'Pending');
        this.setDefaultValue(this.priorities, 'priority_id', 'Low');
    },
    watch: {
        'form.department_id': {
            handler(newDepartmentId) {
                this.departId = newDepartmentId;
                this.doFilterUsersAllDepartment();
            },
            immediate: true
        }
    },
    methods: {


        validateOrderCode() {
            const orderCode = this.form.order_code;

            try {
                const orderCodePattern = new RegExp(this.shopifySetting.orderCodePattern);


                if (!orderCodePattern.test(orderCode)) {
                    this.form.errors.order_code = 'Invalid order code format';

                } else {
                    this.form.errors.order_code = null;

                }
            } catch (e) {
                console.error('Error constructing RegExp:', e);
            }
        },

        uploader(editor) {

            editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {

                return new UploadAdapter(loader);

            };
        },
        handleSearchInput(e) {
            this.doFilterUsersAllDepartment(e.target.value);
        },
        doFilterUsersAllDepartment(searchTerm) {
            const params = {};
            if (searchTerm) {
                params.search = searchTerm;
            }
            if (this.departId) {
                params.department_id = this.departId;
            }

            axios.get(this.route('filter.user_fetch_all_department', params))
                .then((res) => {
                    this.userFetchAllDepartment.splice(0, this.userFetchAllDepartment.length, ...res.data);
                })
                .catch((error) => {
                    console.error('Error filtering users:', error);
                });
        },
        setDefaultValue(arr, key, value) {
            const find = arr.find(i => i.name.match(new RegExp(value + ".*", "i"))); // Case insensitive match
            if (find) {
                this.form[key] = find['id'];
            } else {
                console.warn('Default value not found for:', value);
            }
        },
        fileInputChange(e) {
            let selectedFiles = e.target.files;
            for (let i = 0; i < selectedFiles.length; i++) {
                this.form.files.push(selectedFiles[i]);
            }
        },
        fileRemove(image, index) {
            this.form.files.splice(index, 1);
        },
        getFileSize(size) {
            const i = Math.floor(Math.log(size) / Math.log(1024))
            return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
        },
        fileBrowse() {
            this.$refs.file.click()
        },
        store() {
            this.form.user_id = this.auth.user.id;
            this.form.post(this.route('tickets.store'))
        },
        openShopifyLink() {
            if (this.orderDetails && this.orderDetails.order_status_url) {
                const shopifyUrl = this.orderDetails.order_status_url;
                window.open(shopifyUrl, '_blank');
            }
        },
        openCourierLink() {
            if (this.orderDetails && this.orderDetails.fulfillments[0].tracking_url !== null) {
                const courierUrl = this.orderDetails.fulfillments[0].tracking_url;
                window.open(courierUrl, '_blank');
            }
        },
        openGingkoLink() {
            if (this.orderDetails && this.orderDetails.name) {
                const ginkGoUrl = 'https://chinyere.ginkgoretail.net/search/' + this.orderDetails.name.replace(/^#/, '');
                window.open(ginkGoUrl, '_blank');
            }
        },
        async fetchOrderData() {
            try {
                this.loading = true;
                // Get the order code from the form
                const orderCode = this.form.order_code;

                const orderCodePattern = new RegExp(this.shopifySetting.orderCodePattern);

                if (!orderCodePattern.test(orderCode)) {
                    this.$page.props.flash.error = "Invalid order code format";
                    this.loading = false;
                    return;
                }


                let match = orderCode.match(/\d{6}$/);
                let lastSixDigits = match ? match[0] : '';

                const response = await axios.get(this.route('fetchShopifyOrder', {'order_id': lastSixDigits}));

                if (response) {
                    this.orderDetails = response.data;

                    this.loading = false;

                }
            } catch (error) {
                this.$page.props.flash.error = error.error ?? error.response?.data?.message ?? "Something went wrong,Or synchronization triggered. Please try again";
                console.error('Error fetching order data:', error);
                window.location.reload();
            }
        },

    },
}
</script>
